import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './ProductsPmsHeader.css';

function ProstayAiHeader() {
    const { t } = useTranslation();

    return (
        <div className='product-header prostay-ai-header' style={{ backgroundImage: 'url(/images/prostay-ai-bg.png)' }}>
            <div className='page-content d-flex align-items-center' >
                <div className='col-6 d-flex flex-column'>
                    <div className='chip-dark-blue'>
                         Prostay AI
                    </div>
                    <h1>{t('AI Property Management Software & Smart AI Tools for Seamless Hotel Operations')}</h1>
                    <p className='body-large mt-2'>
                        {t('From direct bookings to front desk inquiries, Prostay AI works around the clock — automating your hotel operations while delivering 5-star guest service.')}
                    </p>
                </div>
                <div className='col img-wrapper'>
                    <img src='/images/prostay-ai-header-img.svg' alt={"Automate Hotel Reservations"}/>
                </div>
            </div>
        </div>
    );
}

export default ProstayAiHeader;
